import React from 'react';
import { Autotext, Box, LeftRow, Row, Subtitle, Title } from '../styles';
import Button from '../../button';
import { observer } from 'mobx-react-lite';
import { rootStore } from '../../../mobx/rootStore';
import { BUTTON_TYPE } from '../../../global/constants';
import SwitchInput from '../../input/switchInput';

interface Props {
  onUpdateSetting: (value: boolean) => void;
  loadingButton: boolean;
  title: string;
  subtitle: string;
  isTemplateProject?: boolean;
}

const SettingCard: React.FC<Props> = (props) => {
  const { onUpdateSetting, loadingButton, title, subtitle, isTemplateProject } = props;
  //Mobx store variables
  const { projectStore, projectTemplateStore } = rootStore;
  const { currentProject: projectDetails } = projectStore;
  const { currentProjectTemplate } = projectTemplateStore;
  const currentProject = isTemplateProject ? currentProjectTemplate : projectDetails;

  const isToggle =
    title === 'Multiple assignee'
      ? currentProject?.multiAssignee
      : title === 'Estimation'
      ? currentProject?.isEstimate
      : title === 'Milestone'
      ? currentProject?.isMilestone
      : false;

  return (
    <Box>
      <Row>
        <LeftRow>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </LeftRow>
        <Autotext>
          {loadingButton ? (
            <Button variant={BUTTON_TYPE.PRIMARY} isLoading={loadingButton} />
          ) : (
            <SwitchInput checked={isToggle || false} onChange={() => onUpdateSetting(!isToggle)} />
          )}
        </Autotext>
      </Row>
    </Box>
  );
};

export default observer(SettingCard);
